import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import { Select } from "shared";
import t from "utils/Lang";
import "./index.scss";
import DatePicker from "react-datepicker";
import moment from "moment";

type ModalTerminateProps = {
  isOpen: boolean;
  toggle: (event?: React.KeyboardEvent<any>) => void;
  contract: any;
  onTerminate: (reason: any, date: string) => void;
  reason: Array<any>;
};

const ModalTerminate = ({
  isOpen,
  toggle,
  contract,
  onTerminate,
  reason,
}: ModalTerminateProps) => {
  const [selected, setSelected] = useState<any>(null);
  const [date, setDate] = useState<any>(moment().format("YYYY-MM-DD"));
  useEffect(() => {
    if (isOpen) {
      setSelected(null);
    }
  }, [isOpen]);
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ padding: 30 }}>
      <div className="modal-terminate__header">
        <span className="modal-terminate__header__title">
          Terminate {contract?.name}
        </span>
      </div>
      <div className="modal-terminate__body">
        <div className="modal-terminate__item">
          <div className="label">
            <span>{t().terminate_date}:</span>
          </div>
          <div style={{ width: 221 }}>
            <DatePicker
              selected={moment(date).toDate()}
              onChange={(date: any) => {
                const val = date
                  ? moment(date).format("YYYY-MM-DD")
                  : moment().format("YYYY-MM-DD");
                setDate(val);
              }}
              dateFormat="yyyy-MM-dd"
              showYearDropdown
            />
          </div>
        </div>
        <div style={{ height: 10 }} />
        <div className="modal-terminate__item">
          <div className="label">
            <span>{t().terminate_reason}:</span>
          </div>
          <Select
            data={reason.map((el) => ({ label: el.name, value: el.id }))}
            label={t().terminate_reason}
            editable
            values={selected ? selected : []}
            onChanged={(val) => setSelected(val)}
          />
        </div>
      </div>
      <div className="modal-terminate__footer">
        <div
          className="modal-terminate__cancel-button"
          onClick={() => toggle()}
        >
          <span>{t().action__cancel}</span>
        </div>
        <div
          className="modal-terminate__confirm-button"
          onClick={() => {
            if (!selected || selected?.length === 0) return;
            onTerminate(selected, date);
          }}
        >
          <span>{t().action__confirm}</span>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTerminate;
